<template>
  <div class="top-rectangle">
    <img
      class="top-rectangle__img"
      style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"
      src="@/assets/images/viewOnMobile/rectangle_top.png"
      alt=""
    >
  </div>
  <img
    class="mobile-qr-panel__device"
    src="@/assets/images/viewOnMobile/img_6891.png"
    alt=""
  >
  <div class="mobile-qr-panel__card">
    <div class="mobile-qr-panel__copy">
      <h3 class="mobile-qr-panel__title">
        {{ t('common.scanQrCode') }}
      </h3>
      <p class="mobile-qr-panel__desc">
        {{ t('common.enjoyRealTimeWeather') }}
      </p>
    </div>
    <img
      class="mobile-qr-panel__qr"
      src="@/assets/images/viewOnMobile/qrcode.png"
      :alt="t('common.qrCode')"
    >
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>
